import { useState } from 'react';
import { de } from '../../i18n/de';
import { GROUP_DEFAULT } from '../../lib/libraryModel';
import { useStoryEnv } from '../../state/storyEnv';
import { useWorkspace } from '../../state/workspace';
import { Field } from '../Field';
import { DraftField } from '../fields/FieldsForm';
import { Modal } from '../Modal';

interface Props {
  /** Wunschposition auf der Pinnwand */
  pos: { x: number; y: number };
  onClose: () => void;
}

/** Neuer Rahmen (Gruppe) auf der Pinnwand eines Bereichs. */
export function NewGroupDialog({ pos, typeId, onClose, onCreated }: { pos: Props['pos']; typeId: string; onClose: () => void; onCreated: () => void }) {
  const { actions } = useStoryEnv();
  const ws = useWorkspace();
  const [name, setName] = useState('');
  const [color, setColor] = useState('#4f6d8f');
  const [busy, setBusy] = useState(false);
  const create = async (): Promise<void> => {
    if (busy) return;
    setBusy(true);
    try {
      // der Rahmen erscheint um die Wunschposition herum
      const cs = await actions.createGroup({ name: name.trim() || de.library.groupDefault, typeId, color, x: pos.x - GROUP_DEFAULT.w / 2, y: pos.y - GROUP_DEFAULT.h / 2 });
      const group = cs?.groups[0];
      if (group) {
        ws.select({ kind: 'group', id: group.id });
        onCreated();
      }
    } finally {
      setBusy(false);
    }
  };
  return (
    <Modal
      title={de.library.newGroup}
      onClose={onClose}
      footer={
        <>
          <button className="btn" onClick={onClose}>
            {de.common.cancel}
          </button>
          <button className="btn primary" type="submit" form="new-group" disabled={busy} data-testid="create-group">
            {de.add.create}
          </button>
        </>
      }
    >
      <form
        id="new-group"
        className="col"
        data-testid="new-group-dialog"
        onSubmit={(e) => {
          e.preventDefault();
          void create();
        }}
      >
        <DraftField label={de.library.groupName} value={name} onSave={setName} testId="new-group-name" />
        <Field label={de.library.groupColor}>
          <input type="color" value={color} onChange={(e) => setColor(e.target.value)} data-testid="new-group-color" />
        </Field>
        <div className="muted small">{de.library.groupHint}</div>
      </form>
    </Modal>
  );
}
